import React from "react";
import IuManagementPageBase from "../../SHARED/components/IuManagementPageBase";
import {
  ADMIN_DATA_MANAGEMENT_LINKS,
  IU_MANAGEMENT_PAGE_TITLE,
} from "../../SHARED/iuManagementPageConfig";

const AdminDataManagement = () => (
  <IuManagementPageBase
    title={IU_MANAGEMENT_PAGE_TITLE.data}
    links={ADMIN_DATA_MANAGEMENT_LINKS}
  />
);

export default AdminDataManagement;
